import styled from 'styled-components';

export const HrStyled = styled.hr`
  margin: 0;
  border: 0;
  height: 1px;
  background: #e5e5e5;
`;
